import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { AddressFormFactory } from '../../../../../../form-factories/address-form-factory';
import { EpSelfEnrolmentFormGroup } from './ep-self-enrolment-form-group';
import { EpSelfEnrolmentAboutFormGroup } from './ep-self-enrolment-about-form-group';
import { EmployerMailingAddressFormGroup } from '../../../../../../forms/employer-mailing-address-form-group';
import { EmployerPrimaryContactFormGroup } from '../../../../../../forms/employer-primary-contact-form-group';
import { EmployerAdditionalContactFormGroup } from '../../../../../../forms/employer-additional-contact-form-group';
import { CANADA_COUNTRY_CODE } from '../../../../../../consts/consts';
import { atLeastOneSigningAuthorityValidator } from '../validators/at-least-one-signing-authority.validator';
import { emailValidator } from '../../../../../../validators/email.validator';
import { maxFileSizeValidator } from '../../../../../shared/components/form-components/file-uploader/file-upload-field/max-file-size-validator';

export class EpSelfEnrolmentFormFactory {
  public static buildForm(): EpSelfEnrolmentFormGroup {
    return new FormGroup(
      {
        about: EpSelfEnrolmentFormFactory.buildAboutFormGroup(),
        headOfficeAddress: AddressFormFactory.createAddressForm(),
        mailingAddress: EpSelfEnrolmentFormFactory.buildMailingAddressFormGroup(),
        primaryContact: EpSelfEnrolmentFormFactory.buildPrimaryContactFormGroup(),
        additionalContacts: new FormArray<EmployerAdditionalContactFormGroup>([]),
        logo: new FormControl<File[] | null>(null, { validators: maxFileSizeValidator(3) })
      },
      { validators: [atLeastOneSigningAuthorityValidator] }
    );
  }

  public static buildAboutFormGroup(): EpSelfEnrolmentAboutFormGroup {
    return new FormGroup({
      name: new FormControl<string | null>(null, { validators: [Validators.required, Validators.maxLength(60)] }),
      shortName: new FormControl<string | null>(null, { validators: [Validators.required, Validators.maxLength(50)] }),
      craPayrollRemittanceAccountNumber: new FormControl<string | null>(null)
    });
  }

  public static buildMailingAddressFormGroup(): EmployerMailingAddressFormGroup {
    return new FormGroup({
      attention: new FormControl<string | null>(null),
      sameAsHeadOffice: new FormControl<boolean>(false, { nonNullable: true }),
      address: AddressFormFactory.createAddressForm()
    });
  }

  public static buildPrimaryContactFormGroup(): EmployerPrimaryContactFormGroup {
    return new FormGroup({
      firstName: new FormControl<string | null>(null, { validators: [Validators.required] }),
      lastName: new FormControl<string | null>(null, { validators: [Validators.required] }),
      jobTitle: new FormControl<string | null>(null),
      email: new FormControl<string | null>(null, { validators: [Validators.required, emailValidator] }),
      phoneNumber: new FormControl<string | null>(null, { validators: [Validators.required] }),
      phoneNumberCountryCode: new FormControl<string | null>(CANADA_COUNTRY_CODE, {
        validators: [Validators.required]
      }),
      hasSigningAuthority: new FormControl<boolean>(false, { nonNullable: true }),
      isPrimaryContact: new FormControl<boolean>(true, { nonNullable: true }),
      address: AddressFormFactory.createAddressForm()
    });
  }

  public static buildAdditionalContactFormGroup(): EmployerAdditionalContactFormGroup {
    const formGroup = new FormGroup({
      firstName: new FormControl<string | null>(null, { validators: [Validators.required] }),
      lastName: new FormControl<string | null>(null, { validators: [Validators.required] }),
      jobTitle: new FormControl<string | null>(null),
      email: new FormControl<string | null>(null, { validators: [Validators.required, emailValidator] }),
      phoneNumber: new FormControl<string | null>(null, { validators: [Validators.required] }),
      phoneNumberCountryCode: new FormControl<string | null>(CANADA_COUNTRY_CODE, {
        validators: [Validators.required]
      }),
      hasSigningAuthority: new FormControl<boolean>(false, { nonNullable: true }),
      isPrimaryContact: new FormControl<boolean>(false, { nonNullable: true }),
      contactTopic: new FormControl<string | null>(null, { validators: [Validators.required] }),
      address: AddressFormFactory.createAddressForm()
    });
    formGroup.controls.address.disable();
    return formGroup;
  }
}
